import {api} from "./axios"
export const columnMapApi = {
    save: (data:any) => api.post("/map-column/save", data),
    update:(id:string , data:any) => api.put(`/map-column/update/${id}`, data),
    check:(tokenId:string,platform:string)  => api.get(`/map-column/check?tokenId=${tokenId}&platform=${platform}`),

}
    